import { apiFetch } from "../../lib/utils";

const NullReportingEndPoint = "/NullReporting";

export type NullReportingSnapshot = {
  id: number;
  supplierOrgId: string;
  period: string;

  reportedBy?: string | null;
  reportedTime?: string | null;
  status?: number | null;
  departmentId?: number | null;

  totalAmountPeriod: number;
  historyMonths: number;
  zeroMonths: number;
  zeroRatio: number;
  zeroDeviationValue: number;

  classification: number; // 0 None, 1 Yellow, 2 Red, 3 NoThreshold
  calcStatus: number;     // 0 Unknown, 1 Running, 2 OK, 3 Failed
  calcMessage?: string | null;
  calculatedAt?: string | null;
  calcVersion?: string | null;
  hasInternalComment?: boolean;
};

export type NullReportingRun = {
  id: number;
  period: string;
  startedAt: string;
  endedAt?: string | null;
  status: number; // 0/1/2/3
  message?: string | null;
  durationMs?: number | null;
  suppliersInScope?: number | null;
  snapshotsUpserted?: number | null;
  snapshotsFailed?: number | null;
  triggeredBy?: string | null;
};

 const GetSnapshots = async (period: string) => {
  const res = await apiFetch(`${NullReportingEndPoint}/api/snapshots/${period}`, "GET");
  if (!res.ok) throw new Error(`Failed to fetch snapshots: ${res.statusText}`);
  return res.json() as Promise<{ snapshots: NullReportingSnapshot[]; lastRun: NullReportingRun | null }>;
};

 const RefreshSnapshots = async (period: string) => {
  const res = await apiFetch(`${NullReportingEndPoint}/api/snapshots/refresh/${period}`, "POST");
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `Failed to refresh: ${res.statusText}`);
  }
  return res.json();
};

 const GetRuns = async (period: string) => {
  const res = await apiFetch(`${NullReportingEndPoint}/api/runs/${period}`, "GET");
  if (!res.ok) throw new Error(`Failed to fetch runs: ${res.statusText}`);
  return res.json() as Promise<NullReportingRun[]>;
};
 const GetAllThresholds = async () => {
  const res = await apiFetch(`${NullReportingEndPoint}/api/thresholds/all`, "GET");
  if (!res.ok) throw new Error(`Failed to fetch thresholds: ${res.statusText}`);
  return res.json();
};

// const UpsertThreshold = async (payload: any) => {
//   const res = await apiFetch(
//     `${NullReportingEndPoint}/api/thresholds`,
//     "POST",
//     JSON.stringify(payload),
//     { "Content-Type": "application/json" }
//   );
//   if (!res.ok) throw new Error(`Failed to save threshold: ${res.statusText}`);
//   return res.text();
// };
const UpsertThreshold = async (payload: {
  supplierOrgNr: string;
  limitYellow?: number | null;
  limitRed?: number | null;
  minHistoryMonths: number;
}): Promise<any> => {
  const response = await apiFetch(
    `${NullReportingEndPoint}/api/thresholds`,
    "POST",
    JSON.stringify(payload),
    { "Content-Type": "application/json" }
  );
  if (!response.ok) throw new Error(`Failed to save threshold: ${response.statusText}`);
  return await response.text();
};

const GetSupplierDetails = async (orgNr: string, months = 24): Promise<any> => {
  const response = await apiFetch(`${NullReportingEndPoint}/api/supplier/${orgNr}?months=${months}`, "GET");
  if (!response.ok) throw new Error(`Failed to fetch supplier null reporting details: ${response.statusText}`);
  return await response.json();
};
const GetSupplierYear = async (orgNr: string, year: number): Promise<any> => {
  const res = await apiFetch(`${NullReportingEndPoint}/api/supplier/year/${orgNr}/${year}`, "GET");
  if (!res.ok) throw new Error(`Failed to fetch supplier year: ${res.statusText}`);
  return res.json();
};

export const NullReporting = {
    GetSnapshots,
    RefreshSnapshots,
    GetRuns,
    GetAllThresholds,
    UpsertThreshold,
    GetSupplierDetails,
    GetSupplierYear
}